// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/navigation/navbar/app/css/app.css
// module id = 501
// module chunks = 0